import {Component, input} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';

@Component({
    selector: 'app-wrapper',
    templateUrl: './auth-wrapper.component.html',
    styleUrls: ['./auth-wrapper.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        TranslateModule,
        AngularSvgIconModule
    ]
})
export class AuthWrapperComponent
{
    public readonly title = input.required<string>();

    public readonly showBackButton = input<boolean>(false);

    public readonly showTitle = input<boolean>(true);

    public goBack(event: Event): void
    {
        window.history.back();
        
        event.stopPropagation();
    }
}
